import { SalePage } from '../pages/SalePage';

export function ResponsiveSalePage() {
  return <SalePage />;
}
